import Post from "./post";
import Comment from "./comment";

import { default as PermissionSchema } from "../../vue-ocom/grouppermissions/schema/index.js";

export default {
  Post,
  Comment,

  ...PermissionSchema /* For Schema */,
};
